import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetAllRoundActive = createAsyncThunk(
  "ActiveRound/GetActiveRound",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDownsManager/GetAllRoundActive",
        parameters
      );

      const data = response.data.result;
      console.log(data, "app");
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const AllRoundActive = createSlice({
  name: "AllRoundActive",
  initialState: {
    AllRoundActive: [],
    loadingAllRoundActive: false,
    errorAllRoundActive: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllRoundActive.pending, (state, action) => {
        state.loadingAllRoundActive = true;
        state.AllRoundActive = action.payload;
        state.errorAllRoundActive = null;
      })
      .addCase(GetAllRoundActive.fulfilled, (state, action) => {
        state.loadingAllRoundActive = false;
        state.AllRoundActive = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllRoundActive.rejected, (state, action) => {
        state.loadingAllRoundActive = false;
        state.errorAllRoundActive = action.payload;
      });
  },
});

export default AllRoundActive.reducer;
